import { translationActions } from '../../../../../store/translationSlice';
import store from '../../../../../store';
import { remoteModalsActions } from '../../../../../store/remoteModalsSlice';
import { translateModalId } from './TranslateModal';
import { informationActions } from '../../../../../store/informationSlice';
import validationsStore from '../../../../../store/validation/validationStore';

export const onCancelTranslateModal = () => {
  const storeModal = store.getState().remoteModalsSlice.modals.translateModal
    .data as any as { fieldId: string };
  const fieldId = storeModal.fieldId;
  const langs = store.getState().translationSlice[fieldId]?.langs;
  if (!fieldId || !langs) return;
  store.dispatch(
    informationActions.update({
      id: 'isLanguageSelected',
      selected: false,
    }),
  );

  langs.forEach((c) => {
    store.dispatch(
      translationActions.markAsQueried({
        id: fieldId,
        langId: String(c.id),
        hasQueriedServer: false,
      }),
    );
    store.dispatch(
      translationActions.markIsTemporalyTranslated({
        id: fieldId,
        langId: String(c.id),
        isTemporalyTranslated: false,
      }),
    );
    validationsStore.setFieldValue(
      `translation${fieldId}`,
      String(c.id),
      c.currentValue,
    );
    if (c.currentValue)
      store.dispatch(
        translationActions.markIsTranslated({
          id: fieldId,
          langId: String(c.id),
          isTranslated: true,
        }),
      );
  });
  store.dispatch(remoteModalsActions.close(translateModalId));
};
